import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper(".js-hallCard3Swiper", {
  slidesPerView: "auto",
  spaceBetween: 10,
});
